import type { ValueOf } from '@weft/utils';
import { oz } from '@weft/utils';

export const CONTRACT_TERMINATION_OPTIONS = Object.freeze({ 
  Immediate: 'immediate',
  EndOfBillingCycle: 'endOfBillingCycle',
});

export type ContractTerminationOptions = ValueOf<typeof CONTRACT_TERMINATION_OPTIONS>;

export const ContractTerminationRequestSchema = oz.object({
  terminationOption: oz.nativeEnum(CONTRACT_TERMINATION_OPTIONS),
}).openapi('ContractTerminationRequest');

export type ContractTerminationRequestPayload = oz.infer<typeof ContractTerminationRequestSchema>;